export default __webpack_public_path__ + "static/media/0_lower_right.924c9e08.svg";